import { createSelector } from 'reselect';

import type { FlagValuesMap } from '@/domains/core/flags/flags.state';

import { mapAbPool } from '../utils/mapAbPool/mapAbPool';

export const selectAbPool = createSelector(
  [(_, selectFlagValuesMap: FlagValuesMap) => selectFlagValuesMap],
  (abTests) => mapAbPool(abTests),
);
